module.exports = __webpack_public_path__ + "img/video_bg2.251d20c9.svg";